import React, {
    useState,
    useEffect
} from 'react';

import { getBasketData} from "../router";

import * as UTILS from "../utils";

import HeartIcon from '../svg/heart';
import LoadingIndicator from './loading-indicator';

export default function InstanceBasketSummary(props) {

    const [ticketGroup, setTicketGroup] = useState(null);
    const [ticketsTotal, setTicketsTotal] = useState(null);

    const { data: basketData, isFetching } = getBasketData();

    useEffect(() => {
        if (!basketData || !basketData.tickets) return;

        let tickets = UTILS.getTicketsByInstance(basketData.tickets);
        let tickets_total = UTILS.getTicketsTotal(tickets);

        const grouped_tickets = UTILS.groupTicketsByInstance(tickets);

        setTicketsTotal(tickets_total.toFixed(2));
        setTicketGroup(grouped_tickets[0]);

    }, [basketData]);

    return (
        <div className="instance-basket-summary basket-summary">
            {basketData && basketData.tickets.length && ticketGroup ?
                <>
                    <p className="basket-summary__total">
                        {isFetching && !props.showDonations ? 
                                <LoadingIndicator />
                            :
                                <>
                                    <span>
                                        Total
                                    </span>
                                    <span>{`£${ticketsTotal}`}</span>
                                </>
                        } 
                    </p>
                    {props.showDonations && props.donationsTotal ?
                        <p className="basket-summary__item basket-summary__item--donation">
                            <span>Total donation</span>
                                {props.queriesPending || isFetching ?
                                    <LoadingIndicator />
                                :
                                    <span className='basket-summary__item--total'><HeartIcon /> {`£${props.donationsTotal?.toFixed(2)}`}</span>
                                }
                        </p>
                        :null
                    }
                </>
                :null
            }
        </div>
    );
}